var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 11.9997C18.6666 15.6797 15.6799 18.6663 11.9999 18.6663C8.31992 18.6663 5.33325 15.6797 5.33325 11.9997C5.33325 8.31967 8.31992 5.33301 11.9999 5.33301C15.6799 5.33301 18.6666 8.31967 18.6666 11.9997Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4734 14.1202L12.4068 12.8868C12.0468 12.6735 11.7534 12.1602 11.7534 11.7402V9.00684",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionLog);
export default __webpack_public_path__ + "static/media/action-log.40e1ccec4bf9663bf5538d18b5e4c377.svg";
export { ForwardRef as ReactComponent };